// extracted by mini-css-extract-plugin
export default {"cautionBox":"F_-z"};